/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * jelled services
 * OpenAPI spec version: 1.0.0
 */

/**
 * onboarding step enums
 */
export type OnboardingStep = typeof OnboardingStep[keyof typeof OnboardingStep];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OnboardingStep = {
  advanced_email_responder_banner_shown: 'advanced_email_responder_banner_shown',
  set_twin_profile: 'set_twin_profile',
  start_conversation: 'start_conversation',
  email_responder: 'email_responder',
  twin_share_url_generated: 'twin_share_url_generated',
  email_responder_modal_shown: 'email_responder_modal_shown',
  conversation_modal_shown: 'conversation_modal_shown',
  my_twin_modal_shown: 'my_twin_modal_shown',
  twin_profile_update_finished: 'twin_profile_update_finished',
  twin_ftux_tour_completed: 'twin_ftux_tour_completed',
  slack_settings_modal_shown: 'slack_settings_modal_shown',
  insights_generation_triggered: 'insights_generation_triggered',
  slack_insights_generation_triggered: 'slack_insights_generation_triggered',
} as const;
